<template>
  <div class="content-form">
    <p class="title-section">{{ $t('driver_onboarding.profile.identity.identity_card') }}</p>

    <div class="columns">
      <div class="field column">
        <InputField
          type="number"
          name="IDCard"
          :labelName="$t('driver_onboarding.profile.identity.identity_card')"
          :errorMessage="isValidIdNumber.message"
          :showError="isValidIdNumber.value === false"
          :initValue="idNumber"
          @onChange="onChangeIdNumber"
        />
      </div>
      <div class="field column">
        <BDateField
          :labelName="$t('driver_onboarding.profile.identity.id_issue_date')"
          :minDate="configuration.min_date"
          :maxDate="configuration.max_date"
          :value="idIssueDateValue"
          placeholder="DD/MM/YYYY"
          @onChange="onChangeIdIssueDate"
        />
      </div>
    </div>
    <div class="columns">
      <div class="field column">
        <BAutocomplete
          :label="$t('driver_onboarding.profile.identity.id_issue_place')"
          :placeholder="$t('driver_onboarding.profile.identity.id_issue_place_hint')"
          :data="issuePlaceOptions"
          :openOnFocus="true"
          :initValue="idIssuePlace"
          @onChange="onChangeIdIssuePlace"
        />
      </div>
      <div class="field column">
        <BAutocomplete
          :label="$t('driver_onboarding.profile.identity.id_native_place')"
          :placeholder="$t('driver_onboarding.profile.identity.id_native_place_hint')"
          :data="nativePlaceOptions"
          :openOnFocus="true"
          :initValue="idNativePlace"
          @onChange="onChangeIdNativePlace"
        />
      </div>
    </div>
  </div>
</template>
<script>
import InputField from "@/components/InputField.vue";
import BDateField from "@/components/BDatePicker";
import BAutocomplete from "@/components/BAutocomplete";
import { mapGetters } from "vuex"

export default {
  components: {
    InputField,
    BDateField,
    BAutocomplete
  },  
  data() {
    const today = new Date();
    return {
      idNumber: null,
      idIssueDate: null,
      idIssuePlace: null,
      idNativePlace: null,

      configuration: {
        min_date: new Date(
          today.getFullYear() - 60,
          today.getMonth(),
          today.getDate()
        ),
        max_date: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        )
      },

      issuePlaceOptions: this.$constants.DATA.ID_ISSUE_PLACE || [],
      nativePlaceOptions: this.$constants.DATA.ID_NATIVE_PLACE || [],

      issue_place: [],
      native_place: []      
    };
  },
  computed : {
    ...mapGetters(["formData"]),
    isValidIdNumber () {
      let result = {
        value: null,
        message: ''
      }
      if(this.idNumber === undefined) return true
      if (this.idNumber !== null) {
        const length = this.idNumber.length
        result.value = length === 9 || length === 12
        result.message = result.value
          ? ''
          : this.$t('driver_onboarding.profile.identity.invalid_id_number')         
      }
      
      return result  
    },
    idIssueDateValue () {
      const date = this.idIssueDate
      let result = date
      if (date) {
        const dateArray = date.split('/')
        result = new Date(new Date(`${dateArray[1]}/${dateArray[0]}/${dateArray[2]}`))
      }
      return result
    },   
  },  
  methods: {
    setIdentityProfile () {
      this.$store.dispatch('setIdentityProfile', {
        id_number: this.idNumber,
        id_issue_date: this.idIssueDate,
        id_issue_place: this.idIssuePlace,
        id_native_place: this.idNativePlace
      })
    },
    onChangeIdNumber (value) {
      this.idNumber = value
      this.setIdentityProfile()
    },
    onChangeIdIssueDate (value) {
      this.idIssueDate = `${value.getDate()}/${value.getMonth()+1}/${value.getFullYear()}`
      this.setIdentityProfile()
    },
    onChangeIdIssuePlace (value) {
      this.idIssuePlace = value
      this.setIdentityProfile()
    },
    onChangeIdNativePlace (value) {
      this.idNativePlace = value
      this.setIdentityProfile()
    },
  },
  created() {
    const formData = this.formData
    if (formData) {
      this.idNumber = formData.id_number
      this.idIssueDate = formData.id_issue_date
      this.idIssuePlace = formData.id_issue_place
      this.idNativePlace = formData.id_native_place
    }
  }
};
</script>
<style lang="scss" scoped>
.content-form {
  p.title-section {
    margin-bottom: 10px !important;
  }
}
</style>
